import * as Yup from "yup";
import { ContactUsField } from "../types";
import {
  EMAIL_VALIDATION_SCHEMA,
  LENGTH_VALIDATION,
  PHONE_VALIDATION_SCHEMA,
} from "src/constants/formValidation";

export const CONTACT_US_VALIDATION_SCHEMA = Yup.object().shape({
  [ContactUsField.name]: LENGTH_VALIDATION(1, 100),
  [ContactUsField.phone]: PHONE_VALIDATION_SCHEMA,
  [ContactUsField.email]: EMAIL_VALIDATION_SCHEMA,
  [ContactUsField.question]: LENGTH_VALIDATION(1, 500),
});
